// extracted by mini-css-extract-plugin
export default {"range":"RangeSlider_range__47ASX"};